<div class="video-wrapper d-flex flex-column position-relative w-100">
	@if(retryFailed === true){
	<div
		class="video-overlay d-flex w-100 h-100 border bg-dark rounded-2 justify-content-center align-items-center z-3">
		<div class="retry-error-body">
			<p class="text-black">Video failed to load. Please try again.</p>
			<button class="btn btn-primary d-flex justify-content-center align-items-center gap-2"
				(click)="reloadVideo()">
				Retry
				@if(isLoading === true){
				<div class="spinner-border small-spinner" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
				}
			</button>
		</div>
	</div>
	} @else if(videoSignedUrl) {
	<div class="h-100" [style.min-height.px]="260">
		<video #videoEle controls class="w-100 h-100 object-fit-contain bg-secondary-subtle flex-1"
			[class.border-0]="noBorderRadius()" [class.rounded-0]="noBorderRadius()" preload="metadata"
			(error)="onVideoError()" (abort)="onAbort()" (play)="onPlay()" (pause)="onPause()"
			(stalled)="onVideoStalled()" (waiting)="onVideoWaiting()">
			<source [src]="videoSignedUrl" (error)="videoError()" />
		</video>
	</div>
	}
	<ng-content></ng-content>
</div>